import { Form } from '@unform/web';
import styled from 'styled-components';

export const FormWrapper = styled(Form)`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  width: 100%;
  gap: 2.4rem;
`;
